// extracted by mini-css-extract-plugin
export default {"apiDocsButton":"ApiDocsButton_apiDocsButton__gEOAL","text":"ApiDocsButton_text__411CT"};